import styled from "styled-components";


import * as UI from "~/src/modules/ui-kit";

import useProductLineEditor from "./useProductLineEditor";
import useProductLinePreviewFinder from "../../../../clients/productSearch/useProductLinePreviewFinder";
import useNotifications from "../../../../components/Notifications";
import { useUnsavedChangesEditor } from "../../../../modules/unsaved-changes";
import FileUpload from "../../../products/ui/components/form/Media/FileUpload";
import Parameters from "../../components/Parameters";


const ImagePreview = styled.img`
    max-width: 100%;
    max-height: 200px;
    object-fit: contain;
    border-radius: 4px;
`;

const ErrorMessage = styled.p`
    color: #c00;
    font-size: 0.9rem;
    margin: 0;
`;

export default function ProductLineEditor(props) {
    const { productLine, guard } = props;

    const { reader, reset, save, writer, error } = useProductLineEditor(productLine, guard?.isDirtyRef);

    const findPreview = useProductLinePreviewFinder();
    const notifications = useNotifications();

    useUnsavedChangesEditor(guard, save);

    async function assignProductImage() {
        const preview = await findPreview(reader.brandID, reader.key);

        if (!preview) {
            notifications.error("No product with a picture was found in the Product line.");
            return;
        }

        writer.image(preview);
    }

    function onSubmit(event) {
        event.preventDefault();
        return save?.(event);
    }

    function onReset() {
        reset();
        if (guard) guard.isDirtyRef.current = false;
    }

    return (
        <UI.Form
            onSubmit={ onSubmit }
            onReset={ onReset }
        >
            <UI.Field>
                <UI.FieldLabel>Key</UI.FieldLabel>
                <UI.FieldDescription>Products having value of &quot;Product line&quot; Parameter matching the key will belong to this Product Line</UI.FieldDescription>
                <UI.TextInput
                    onChange={ writer.key }
                    placeholder="Product Line key"
                    value={ reader.key ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Name</UI.FieldLabel>
                <UI.FieldDescription>It is sufficient to fill in just one (arbitrary) language when the name is the same in all languages</UI.FieldDescription>
                <UI.TranslatedInput
                    label="name"
                    onChange={ writer.name }
                    value={ reader.name }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Image</UI.FieldLabel>
                <UI.FieldDescription>Preview picture for the Product Line</UI.FieldDescription>
                <UI.TextInput
                    onChange={ writer.image }
                    placeholder="https://..."
                    value={ reader.image ?? "" }
                />
                <FileUpload
                    brandID={ reader.brandID }
                    onChange={ writer.image }
                >
                    <UI.Button
                        disabled={ !reader.key }
                        onClick={ assignProductImage }
                    >
                        Assign picture from product
                    </UI.Button>
                </FileUpload>
                { reader.image && <ImagePreview src={ reader.image } alt="" /> }
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Parameters</UI.FieldLabel>
                <UI.FieldDescription>Filters available for the Product Line</UI.FieldDescription>
                <Parameters
                    onChange={ writer.parameterIDs }
                    value={ reader.parameterIDs ?? [] }
                />
            </UI.Field>
            { error && <ErrorMessage>{ error }</ErrorMessage> }
            <UI.ButtonGroup>
                <UI.Button type="reset">Reset</UI.Button>
                <UI.Button
                    $appearance="primary"
                    disabled={ !save }
                    type="submit"
                >Save</UI.Button>
            </UI.ButtonGroup>
        </UI.Form>
    );
}
